// PGCET MCA Mock 9 — Analytical Ability & Logical Reasoning (questions 56–70)
const pgcetmcaAnalyticalReasoning = [
  {
    id: 56,
    question: "A wall clock shows the time 4:20. What time will its mirror image (in a vertical plane mirror) appear to show?",
    options: ["A. 7:40", "B. 8:40", "C. 7:20", "D. 8:20"],
    answer: "A"
  },
  {
    id: 57,
    question: "Which of the following capital letters looks exactly the same in its water image (its reflection about a horizontal line below it)?",
    options: ["A. A", "B. M", "C. E", "D. T"],
    answer: "C"
  },
  {
    id: 58,
    question: "Which of the following words, written in capital letters, looks exactly the same when seen in a vertical plane mirror?",
    options: ["A. NOON", "B. TOOT", "C. DEED", "D. RADAR"],
    answer: "B"
  },
  {
    id: 59,
    question: "CAT : DCW :: DOG : ?",
    options: ["A. EPJ", "B. EQK", "C. FQJ", "D. EQJ"],
    answer: "D"
  },
  {
    id: 60,
    question: "ZY : AB :: XW : ?",
    options: ["A. DC", "B. CD", "C. BC", "D. CE"],
    answer: "B"
  },
  {
    id: 61,
    question: "Statement: 'Use our new toothpaste for whiter teeth' — an advertisement by a company. Assumptions: I. People want whiter teeth. II. Advertisements influence people's buying choices. Which assumption(s) is/are implicit?",
    options: ["A. Only I is implicit", "B. Only II is implicit", "C. Either I or II is implicit", "D. Both I and II are implicit"],
    answer: "D"
  },
  {
    id: 62,
    question: "Statement: The municipal corporation has decided to fine people Rs. 500 for littering in public parks. Assumptions: I. The fine will discourage people from littering in parks. II. Every visitor to a public park litters. Which assumption(s) is/are implicit?",
    options: ["A. Only I is implicit", "B. Only II is implicit", "C. Either I or II is implicit", "D. Neither I nor II is implicit"],
    answer: "A"
  },
  {
    id: 63,
    question: "Statement: Only those employees who joined the company before 2015 will receive the special loyalty bonus. Ravi joined the company in 2017. Conclusions: I. Ravi will not receive the special loyalty bonus. II. Ravi is not a sincere employee. Which conclusion(s) follow(s)?",
    options: ["A. Only II follows", "B. Only I follows", "C. Either I or II follows", "D. Neither I nor II follows"],
    answer: "B"
  },
  {
    id: 64,
    question: "Statement: A study says that reading newspapers daily improves one's general knowledge. Conclusions: I. People who do not read newspapers have no general knowledge. II. Everyone who reads newspapers daily will win quiz competitions. Which conclusion(s) follow(s)?",
    options: ["A. Only I follows", "B. Only II follows", "C. Neither I nor II follows", "D. Both I and II follow"],
    answer: "C"
  },
  {
    id: 65,
    question: "In a group of cows and hens, the total number of legs is 14 more than twice the total number of heads. The number of cows in the group is",
    options: ["A. 5", "B. 7", "C. 14", "D. 10"],
    answer: "B"
  },
  {
    id: 66,
    question: "A man has Rs. 480 made up of one-rupee coins, five-rupee notes and ten-rupee notes, with an equal number of each. The total number of coins and notes he has is",
    options: ["A. 45", "B. 60", "C. 75", "D. 90"],
    answer: "D"
  },
  {
    id: 67,
    question: "If 5 machines take 5 minutes to make 5 articles, how many minutes will 100 machines take to make 100 articles?",
    options: ["A. 5", "B. 100", "C. 20", "D. 1"],
    answer: "A"
  },
  {
    id: 68,
    question: "Find the missing number in the matrix (the same rule applies to each row): Row 1: 3, 4, 25; Row 2: 5, 12, 169; Row 3: 8, 15, ?",
    options: ["A. 23", "B. 17", "C. 289", "D. 225"],
    answer: "C"
  },
  {
    id: 69,
    question: "Find the missing number in the matrix (each column follows the same rule): Row 1: 4, 5, 6; Row 2: 3, 2, 7; Row 3: 12, 10, ?",
    options: ["A. 13", "B. 36", "C. 42", "D. 48"],
    answer: "C"
  },
  {
    id: 70,
    question: "Find the missing number in brackets, following the same rule in each set: 3 (20) 7, 5 (34) 12, 6 (?) 8",
    options: ["A. 48", "B. 14", "C. 30", "D. 28"],
    answer: "D"
  }
];

export default pgcetmcaAnalyticalReasoning;
